// # Filename: src/components/poker/PokerTable.jsx
//
// Thin breakpoint dispatcher. Mounts exactly one tier's table component (rather than
// rendering both and toggling visibility with CSS, which is how this used to work and
// is why desktop-tuned sizing formulas kept leaking into/fighting with mobile's).
// See DesktopPokerTable.jsx / TabletPokerTable.jsx / MobilePokerTable.jsx for the
// actual layouts, and hooks/usePokerTableView.js for the shared game/animation logic
// they're all built on.

import React from "react";

import useMediaQuery from "./shared/useMediaQuery";
import DesktopPokerTable from "./DesktopPokerTable";
import TabletPokerTable from "./TabletPokerTable";
import MobilePokerTable from "./MobilePokerTable";

const DESKTOP_MEDIA_QUERY = "(min-width: 1024px)";
const TABLET_MEDIA_QUERY = "(min-width: 640px)";

export default function PokerTable(props) {
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);
  const isAtLeastTablet = useMediaQuery(TABLET_MEDIA_QUERY);

  if (isDesktop) return <DesktopPokerTable {...props} />;
  if (isAtLeastTablet) return <TabletPokerTable {...props} />;
  return <MobilePokerTable {...props} />;
}
